let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aUfX6")).then(() => parcelRequire('4TUmR'));